import { defHttp } from '@/hooks/use-requests';
import type { RequestOptions } from 'types/axios';

// 获取用户信息
export const getUserInfo = (params: any) => {
  return defHttp.get({
    url: `/user/get_user_info/`,
    params,
  });
};
// 更新用户信息
export const updateUserInfo = (id: string, params: any) => {
  return defHttp.post({
    url: `/user/user/${id}`,
    params,
  });
};
// 绑定手机号
export const bindPhone = (params: any, options?: RequestOptions) => {
  params.code = localStorage.getItem('authCode');
  return defHttp.post(
    {
      url: '/user/bind_phone/',
      params,
    },
    options,
  );
};

/**
 * 验证当前手机号和wxid 是否匹配。
 *
 * @param phone 用户手机号码
 * @returns
 * 0 不匹配，需要弹窗确认
 * 1 匹配 不做提示，继续调用登录接口
 *
 */
export const checkBind = (phone: string, verify_code?: string) => {
  return defHttp.post({
    url: '/user/check_bind/',
    params: {
      phone,
      type: 1,
      verify_code,
    },
  });
};

// 获取短信验证码
export const getSmsCode = (params: any) => {
  return defHttp.post({
    url: '/public/send_verify_code/',
    params,
  });
};

// 更新用户经纬度地址
export const updateUserLocation = (id: string, params: any) => {
  return defHttp.post({
    url: `/user/${id}/location/`,
    params,
  });
};
// 助教提现申请/
export const userWithdraw = (params: any) => {
  return defHttp.post({
    url: '/cuebuddy/withdraw/',
    params,
  });
};

// 检查助教当前是否已有 pending 中的提现申请
export const checkWithdrawStatus = (id: string) => {
  return defHttp.get({
    url: `/cuebuddy/check_withdraw/${id}/`,
  });
};

// 退出登陆
export const userLogout = (userId: string) => {
  return defHttp.post({
    url: '/auth/logout/',
    data: { user_id: userId },
  });
};
